import React from 'react';
import {Box, Divider, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import FaShortlist from "../FactureeComponents/FaShortlist";
import ShowCode from "../helpers/ShowCode.js";

const FactureeCompShortlistExmpl = () => {

  const lineHeightExample = `<>
  {/* Condensed line height */}
  <FaShortlist
    data={{
      "Name": "Bert",
      "Surname": "Von der Sesamstraße",
      "Tel": "+49 1234 56890-1",
      "Email": "mailto:bert@bert.de"
    }}
    FirstColWidth={2}
    lineHeight={"condensed"}
    sx={{maxWidth: '420px'}}
    textFormatting={{columnA: 'regular', columnB: 'bold'}}
  />
</>`;

  const columnWidthExample = `<>
  {/* Variable column width */}
  <FaShortlist
    data={{
      "Name": "Bert",
      "Surname": "Von der Sesamstraße",
      "Tel": "+49 1234 56890-1",
      "Email": "mailto:bert@bert.de"
    }}
    FirstColWidth={4}
    sx={{maxWidth: '420px'}}
    textFormatting={{columnA: 'regular', columnB: 'bold'}}
  />
</>`;

  const stylingExample = `<>
  {/* Custom text alignment and formatting */}
  <FaShortlist
    data={{
      "Name": "Bert",
      "Surname": "Von der Sesamstraße",
      "Tel": "+49 1234 56890-1",
      "Email": "mailto:bert@bert.de"
    }}
    FirstColWidth={3}
    sx={{maxWidth: '420px'}}
    textAlign={{columnA: 'left', columnB: 'right'}}
    textFormatting={{columnA: 'italic', columnB: 'bold'}}
  />
</>`;

  const htmlExample = `<>
  {/* Inner HTML in content */}
  <FaShortlist
    data={{
      "Name": "Bert",
      "Surname": "Von der<br/> Sesamstraße",
      "Tel": '<strong>+49</strong>&nbsp;1234568901',
      "Email": "mailto:bert@bert.de"
    }}
    FirstColWidth={3}
    sx={{maxWidth: '420px'}}
    textFormatting={{columnA: 'regular', columnB: 'regular'}}
  />
</>`;

  const firstLineExample = `<>
  {/* With optional first line */}
  <FaShortlist
    firstLine={"strong"}
    data={{
      "Name": "Bert",
      "Surname": "Von der Sesamstraße",
      "Tel": "+49 1234 56890-1",
      "Email": "mailto:bert@bert.de"
    }}
    FirstColWidth={3}
    sx={{maxWidth: '420px'}}
  />
</>`;

  return (
    <Box sx={{padding: '8rem 8vw 2rem 8vw'}}>

      <Typography variant={"h3"} sx={{marginBottom: '2rem', maxWidth: '420px'}}>FaShortlist Component</Typography>
      <Typography>With FaShortlist you can easily display simple key-value data collections in a two colum fashion.</Typography>

      <Divider/>

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>
        Variable line height
      </Typography>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={2}
          lineHeight={"condensed"}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={2}
          lineHeight={"tight"}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={2}
          lineHeight={"normal"}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={2}
          lineHeight={"wide"}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={2}
          lineHeight={"xwide"}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <ShowCode codeString={lineHeightExample} scope={{ React, FaShortlist }} />


      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>
        Variable Column Width
      </Typography>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={3}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={4}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={5}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={6}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'bold'}}></FaShortlist>

      <ShowCode codeString={columnWidthExample} scope={{ React, FaShortlist }} />


      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>
        Variable font sizes, font styles, and alignments
      </Typography>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={3}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textAlign={{columnA: 'left', columnB: 'right'}}
          textFormatting={{columnA: 'italic', columnB: 'bold'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={6}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textAlign={{columnA: 'right', columnB: 'left'}}
          textFormatting={{columnA: 'bold', columnB: 'regular'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={5}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textAlign={{columnA: 'center', columnB: 'center'}}
          textFormatting={{columnA: 'italic', columnB: 'bold-italic'}}></FaShortlist>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={3}
          fontSize={18}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'regular'}}></FaShortlist>

      <ShowCode codeString={stylingExample} scope={{ React, FaShortlist }} />


      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>
        Inner Html on text allowed
      </Typography>

      <FaShortlist
          data={{
            "Name": "Bert",
            "Surname": "Von der<br/> Sesamstraße",
            "Tel": '<strong>+49</strong>&nbsp;1234568901',
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={3}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}
          textFormatting={{columnA: 'regular', columnB: 'regular'}}></FaShortlist>

      <ShowCode codeString={htmlExample} scope={{ React, FaShortlist }} />

      <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>
        Optional first line
      </Typography>

      <FaShortlist
          firstLine={"strong"}
          data={{
            "Name": "Bert",
            "Surname": "Von der Sesamstraße",
            "Tel": "+49 1234 56890-1",
            "Email": "mailto:bert@bert.de"
          }}
          FirstColWidth={3}
          sx={{marginBottom: '1rem', maxWidth: '420px'}}></FaShortlist>

      <ShowCode codeString={firstLineExample} scope={{ React, FaShortlist }} />

      <Typography variant={"h4"} sx={{marginBottom: '0.5rem', marginTop: '3rem'}}>API Reference</Typography>
      <Typography variant={"body2"} color="text.secondary" sx={{marginBottom: '2rem'}}>
        Complete list of all props supported by the FaShortlist component.
      </Typography>

      <TableContainer component={Paper} sx={{marginBottom: '2rem', '& code': {fontSize: '0.875rem'}}}>
        <Table>
          <TableHead>
            <TableRow sx={{backgroundColor: 'primary.main'}}>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '20%'}}>Prop</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '25%'}}>Type</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '15%'}}>Default</TableCell>
              <TableCell sx={{color: 'white', fontWeight: 'bold', width: '40%'}}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell><code>data</code> *</TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>Object</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Key-value pairs to display in two-column format.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>id</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Optional ID attribute for the component container.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>FirstColWidth</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>4</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Width of the first column in grid units (out of 12).</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>convertLinks</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>boolean</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>true</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>When true, automatically converts URLs to clickable links.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>textAlign</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>{'{'}columnA: 'left' | 'center' | 'right', columnB: 'left' | 'center' | 'right'{'}'}</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>{'{'}columnA: 'left', columnB: 'left'{'}'}</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Text alignment for each column.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>textFormatting</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>{'{'}columnA: 'regular' | 'bold' | 'italic' | 'bold-italic', columnB: 'regular' | 'bold' | 'italic' | 'bold-italic'{'}'}</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>{'{'}columnA: 'regular', columnB: 'regular'{'}'}</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Font style and weight for each column.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>fontSize</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>number</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>16</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Font size in pixels for both columns.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>lineHeight</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'condensed' | 'tight' | 'normal' | 'wide' | 'xwide'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"normal"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Line height spacing between rows.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>firstLine</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>'none' | 'normal' | 'strong'</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>"none"</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Style of the first divider line; 'strong' makes it thicker.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><code>sx</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
              <TableCell sx={{color: 'text.secondary'}}>Material-UI sx prop for custom styling of the container.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant={"body2"} color="text.secondary" sx={{fontStyle: 'italic'}}>
        * Required prop
      </Typography>

    </Box>
  );
};

export default FactureeCompShortlistExmpl;
